import React from 'react';
import styles from './Points.module.scss';

interface PointsProps {
  type: 'Default' | 'border' | 'img';
  size: 'sm' | 'md' | 'lg';
  isActive: boolean;
}

const Points: React.FC<PointsProps> = ({
  type = 'Default',
  size = 'md',
  isActive
}) => {
  const styleContent = `point_content-${size}`;

  return (
    <div
      data-testid={`points-${type}`}
      className={`${styles[styleContent]} ${
        isActive ? styles['point_content-active'] : ''
      } ${styles[type]}`}
    >
      {type === 'img' && <img src="assets/Point.png" alt="img" />}
      {type === 'border' && <div />}
    </div>
  );
};

export default Points;
